import { PropsWithChildren } from 'react';
import { Stack } from '@mui/material';

export interface CenteredLayoutProps extends PropsWithChildren {
  height?: string;
}

export const CenteredLayout = ({ children, height = '100%' }: CenteredLayoutProps) => {
  return (
    <Stack
      direction='column'
      justifyContent='center'
      alignItems='center'
      width='100%'
      height={height}
    >
      {children}
    </Stack>
  );
};
